import React from 'react';
import { Helmet } from 'react-helmet';
import Topbar from '../../PulseSurvey/Topbar';
import Insights from './insights';
import { PeapDashboardData } from '../../../utils/pageContent';

const PeapDashboard = ({topbarShow = true}) => {
  return (
    <div className="relative lg:pl-5 lg:mb-[45px]">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{PeapDashboardData.metaTitle}</title>
      </Helmet>
      {topbarShow === true && <Topbar title={PeapDashboardData.title} />}
      <Insights />
    </div>
  );
};

export default PeapDashboard;
